import React from 'react';
import { Box, Typography } from '@mui/material';
import { buySearchCreditTexts } from 'src/common/config/TextMessage';

interface OfferModalFooterProps {
  styles: any;
}

const OfferModalFooter: React.FC<OfferModalFooterProps> = ({ styles }) => {
  return (
    <Box
      sx={{ marginTop: '24px' }}
      className="flex items-center justify-evenly mt-5 md:m-0 flex-col md:flex md:flex-row w-full"
    >
      <div className="flex items-center">
        <Box>
          <img src={process.env.PUBLIC_URL + `/static/images/icons/google.svg`} alt="icon" />
        </Box>
        <Box>
          <img src={process.env.PUBLIC_URL + `/static/images/icons/stars.svg`} alt="icon" />
        </Box>
        <Typography sx={styles?.footerTypoSx}>4.9 rating</Typography>
      </div>

      <Box sx={styles?.subFooterBoxSx}>
        <img src={process.env.PUBLIC_URL + `/static/images/icons/community.svg`} alt="icon" />
        <Typography sx={styles?.footerTypoSx}>
          {buySearchCreditTexts?.footerTextFirst}
        </Typography>
      </Box>

      <Box sx={styles?.subFooterBoxSx}>
        <img src={process.env.PUBLIC_URL + `/static/images/icons/testimonials.svg`} alt="icon" />
        <Typography sx={styles?.footerTypoSx}>
          {buySearchCreditTexts?.footerTextSecond}
        </Typography>
      </Box>
    </Box>
  );
};

export default OfferModalFooter;
